/* The router basename — the app is served at the host root (matches Vite
 * `base` "/"). Empty string so both the router and non-router full-page
 * navigations (e.g. the logout redirect) build correct absolute paths from one
 * source without an import cycle. `${APP_BASENAME}${LOGIN_PATH}` → "/login". */
export const APP_BASENAME = "";

/* Router-relative paths (under the APP_BASENAME). The login screen is
 * canonically served at /login. */
export const LOGIN_PATH = "/login";
/* Studio's invite emails point at {APP_BASE_HOST_URL}/auth?invitation_id=…, a
 * URL fixed by the identity service. We keep /auth as a permanent redirect to
 * LOGIN_PATH (query intact) so invite deeplinks — and any old /auth bookmarks —
 * still land on the login screen. Remove once studio's invite template moves to
 * /login. */
export const INVITE_LOGIN_PATH = "/auth";
/* The Firebase email-action handler (verification/reset links) — the shared
 * project's template action URL points here now that studio's handler is
 * sunset. Same path studio used, so only the host changes in the console. */
export const AUTH_ACTION_PATH = "/auth/action";
export const SIGNUP_PATH = "/signup";
/* Where an authenticated-but-unverified email/password user is parked until
 * they follow the verification link (the verified gate — see session.tsx). */
export const CHECK_EMAIL_PATH = "/check-email";
/* Request a Firebase password-reset email. The reset itself happens on
 * Firebase's hosted page (see firebase.ts sendPasswordReset). */
export const FORGOT_PASSWORD_PATH = "/forgot-password";
/* Public page for AI21 Gateway sign-ins the allowlist rejected (see authErrors.redirectIfEmailNotAllowed). */
export const COMING_SOON_PATH = "/coming-soon";
/* Consent screen for a command-line sign-in: a CLI opens
 * {APP_BASE_HOST_URL}/cli-login?redirect_uri=…&state=…&code=…&client=… and waits on a
 * loopback port for the credential this page posts back. Public — it manages its own
 * auth-status redirect (see CliLoginRoute). */
export const CLI_LOGIN_PATH = "/cli-login";
/* The Harness Optimizer sibling app — same domain, separate deployment
 * (OPSS-374). Used by the app switcher (full browser navigation) and by the
 * auth screens to brand themselves when a signed-out visit to it lands on
 * /login?redirect=/harness… (OPSS-487). */
export const HARNESS_OPTIMIZER_PATH = "/harness";
